import React, { createContext, useContext, useState } from 'react';

interface FicFidcDashboardDateContextData {
  /**
   * Data de competência (yyyy-MM-dd) autoritativa do dashboard FIC/FIDC.
   * `null` significa "mais recente": as consultas seguem o modo legado, sem
   * `date`, e as query keys permanecem nas formas originais.
   */
  date: string | null;
  setDate: (date: string | null) => void;
}

const FicFidcDashboardDateContext =
  createContext<FicFidcDashboardDateContextData | null>(null);

export const FicFidcDashboardDateProvider: React.FC<{
  initialDate?: string | null;
  children: React.ReactNode;
}> = ({ initialDate = null, children }) => {
  const [date, setDate] = useState<string | null>(initialDate);

  return (
    <FicFidcDashboardDateContext.Provider value={{ date, setDate }}>
      {children}
    </FicFidcDashboardDateContext.Provider>
  );
};

/**
 * Fora de `FicFidcDashboardDateProvider` retorna `null`: os consumidores
 * permanecem no comportamento legado (sem `date`), como no Monitor.
 */
export const useFicFidcDashboardDate = () =>
  useContext(FicFidcDashboardDateContext);
